import {
  getIndexPage,
  invitationUser,
  listOrgCourseGoods,
  getAppTestingVOById,
  // withoutApproval,
  reportedMessage,
  hashNotRedMessage,
  getsureUserJoinMes,
  sureUserJoinMes,
  modifyUserRemarkName
} from "@/api/home/index";
import { getOrgUserVO } from "@/api/mine/personalInfo";
import { userApplyOrg } from "@/api/home/joinOrg";
import { Toast, Dialog } from "vant";

import { userJoinOrg } from "@/api/home/joinOrg";
import {
  dataBurialPoint,
  getOrgId,
  obj2StrParams,
  goToH5LoginSystem
} from "@/utils/common.js";
import { getToken } from "@/utils/common.js";
import { getUserIsJoinType } from "@/api/mine/mineExam.js";
let LocaLoadingInstance = null;
export default {
  data() {
    return {
      displayGift: false, //新券包
      couponData: {},
      leadJoin: false,
      contentStatus: 1,
      configDataStatus: 1,
      allDataStatus: 1,
      displayJoinOrg: false,
      cliH: document.documentElement.clientWidth,
      height: Math.floor((this.cliH * 470) / 750) + "px",
      bannerData: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true
        }
      },
      pageList: [],
      isNoPageList: 1,
      isToast: false,
      goodsList: [],
      isNoGoodsList: 1,
      joinOff: false,
      // allTestList: [],
      // isNoAllTestList: 1,
      courseLoad: {
        finished: false,
        page: 1,
        pageSize: 20,
        allCoursseTxt: "点击加载更多"
      },
      applyType: 0, // 0未申请 1已申请
      isJoin: null, // -1未邀请 0=未加入,1=已加入
      showUserIsJoin: false, // 是否展示顶部已加入医院的提示
      orgId: "",
      getToken: getToken() || false,
      courseSystemId: "", //课程体系ID
      userInfo: {}
    };
  },
  computed: {
    // 计算属性的 getter
    isNone: {
      get() {
        let flag = this.configDataStatus == 2 && this.allDataStatus == 2;
        return flag;
      }
    },
    joinState: {
      // 1：未加入 2：已申请 3：已加入
      get() {
        if (!this.getToken) {
          return 1;
        }
        if (this.showUserIsJoin) {
          return 3;
        }
        if (this.applyType == 1) {
          return 2;
        }

        return 1;
      }
    },
    isNoData: {
      get() {
        if (this.isNoPageList != 1 || this.isNoGoodsList != 1) {
          LocaLoadingInstance.clear();
        }
        if (this.isNoPageList == 2 && this.isNoGoodsList == 2) {
          return true;
        }
        return false;
      }
      //
    }
  },
  created() {
    console.log("getToken------------", getToken());
    if (!this.getToken) {
      Dialog.confirm({
        title: "提示",
        message: "您尚未登录，请先登录",
        confirmButtonText: "立即登录"
      })
        .then(() => {
          this.joinOrg({ type: 1 });
        })
        .catch(() => {});
    }
    LocaLoadingInstance = Toast.loading({
      mask: true,
      duration: 0,
      message: "加载中..."
    });
    this.orgId = getOrgId();
    this.getList();
    this.getListOrgCourseGoods();
    if (this.getToken) {
      invitationUser()
        .then(r => {
          this.displayJoinOrg = r;
        })
        .catch(() => {});
      getUserIsJoinType()
        .then(res => {
          this.getOrgUserVOInit(res.type);
          // res.type:-1未邀请 0=未加入,1=已加入  res.applyType:0未申请 1已申请
          // if (!res) return false;
          if (res.type !== 1 && res.applyType === 0) {
            this.noJoined();
          }
          if (res.type != 1 || res.applyType == 1) {
            this.leadJoin = true;
          }
          if (res.type == 1) {
            this.leadJoin = false;
            if (
              window.PAGE_PARAMS.testingId &&
              !sessionStorage.getItem("testingInfo")
            ) {
              this.testingInfo();
            }
          }
          this.applyType = res.applyType;
          this.isJoin = res.type;
          // 是否展示顶部已加入医院的提示
          this.getsureUserJoinMes();
        })
        .catch(() => {});

      hashNotRedMessage()
        .then(res => {
          if (res && res.id) {
            this.couponData = res;
            this.displayGift = true;
            this.courseSystemId = res.courseSystemId;
          }
        })
        .catch(() => {});
    }
    dataBurialPoint("A001", "A001-001", window.PAGE_PARAMS);
  },
  methods: {
    //备注成功
    remarkNameSuccess(remarkName) {
      if (this.isJoin === 1) {
        this.modifyUserRemarkName(remarkName);
      } else {
        this.userApplyOrgInit(remarkName);
      }
    },
    //更改用户备注名
    modifyUserRemarkName(remarkName) {
      modifyUserRemarkName({ id: this.userInfo.id, remarkName }).then(res => {
        if (res) {
          Toast("提交成功");
        }
      });
    },
    //获取用户信息
    getOrgUserVOInit(type = null) {
      getOrgUserVO().then(res => {
        this.userInfo = res || {};
        if (type === 1 && !this.userInfo.remarkName) {
          this.$refs.remark.init();
        }
      });
    },
    //根据testingId获取考试信息
    testingInfo() {
      getAppTestingVOById({ testingId: window.PAGE_PARAMS.testingId }).then(
        res => {
          if (!res.hashRoleTesting) {
            Dialog.confirm({
              title: "提示",
              message: "您无权限参与本场考试",
              confirmButtonText: "确定",
              showCancelButton: false
            })
              .then(() => {})
              .catch(() => {});
            return;
          }
          this.$refs.testing.init(res);
          sessionStorage.setItem("testingInfo", true);
        }
      );
    },
    //是否收到信息
    getsureUserJoinMes() {
      getsureUserJoinMes()
        .then(r => {
          this.showUserIsJoin = r;
          if (r) {
            this.leadJoin = true;
          }
        })
        .catch(() => {});
    },
    //点击申请加入
    noJoined() {
      Dialog.confirm({
        title: "提示",
        message: "您尚未加入当前医院，请先加入医院",
        confirmButtonText: "申请加入"
      })
        .then(() => {
          this.$refs.remark.init();
        })
        .catch(() => {});
    },
    clickBackFn(id) {
      dataBurialPoint("A001", "A001-003", { id: id });
    },
    getListOrgCourseGoods() {
      let _this = this,
        data = {
          pageNum: _this.courseLoad.page,
          orgId: _this.orgId,
          pageSize: _this.courseLoad.pageSize
        };
      listOrgCourseGoods(data)
        .then(r => {
          this.goodsList.push(...r.list);
          this.isNoGoodsList = r.list.length == 0 ? 2 : 3;
          if (r.list.length < _this.courseLoad.pageSize || r.isLastPage) {
            _this.courseLoad.finished = true;
            _this.courseLoad.allCoursseTxt = "";
          }
          if (r.list.length === 0) {
            this.allDataStatus = 2;
          } else {
            this.contentStatus = 3;
          }
        })
        .catch(() => {
          this.isNoPageList = 2;
        });
    },
    onLoad(type) {
      // type: 1课程加载, 2考试加载
      if (type == 1) {
        this.courseLoad.page++;
        this.getListOrgCourseGoods();
      }
    },
    reportedMessageFn(val) {
      if (val) {
        dataBurialPoint("A001", "A001-008");
      } else {
        dataBurialPoint("A001", "A001-009");
      }
      this.displayGift = false;
      reportedMessage({ id: this.couponData.id })
        .then(() => {})
        .catch(() => {});
    },
    jump() {
      this.reportedMessageFn("jump");
      setTimeout(() => {
        window.location.href = "./coupon.html";
      }, 800);
    },
    link(item) {
      dataBurialPoint("A001", "A001-005");
      let url = null;
      let skipType = item.skipType;
      switch (skipType) {
        case 1:
          url = item.redirectUrl;
          break;
        case 2:
          url = "./goodsDetails.html?id=" + item.courseId;
          break;
        case 3:
          this.getTesting(item.courseId);
          break;
        case 4:
          url = "./notice.html?id=" + item.id;
          break;
      }
      if (skipType !== 3) {
        setTimeout(() => {
          window.location.href = url;
        }, 500);
      }
    },
    getTesting(testingId) {
      getAppTestingVOById({ testingId: testingId }).then(res => {
        let params = obj2StrParams({
          testPaperId: res.testPaperId,
          testPaperNo: res.testPaperNo,
          testingId: res.id,
          againFlag: 1
        });
        //跳转考试须知
        window.location.href = "./testInstructions.html" + params;
      });
    },
    testAll() {
      dataBurialPoint("A001", "A001-004-04");
      setTimeout(() => {
        window.location.href = "./mineExam.html";
      }, 500);
    },
    joinOrg(val) {
      console.log(!this.getToken);
      if (!this.getToken) {
        goToH5LoginSystem();
        return;
      }
      if (val.type == 1) {
        dataBurialPoint("A001", "A001-007");
        this.$refs.remark.init();
        // withoutApproval()
        //   .then(res => {
        //     if (res) {
        //       this.userApplyOrgInit();
        //       return;
        //     } else {
        //       this.$refs.remark.init();
        //     }
        //   })
        //   .catch(() => {
        //     this.$refs.remark.init();
        //   });
      } else if (val.type == 2) {
        dataBurialPoint("A001", "A001-006");
        if (this.joinOff) {
          return;
        }
        this.joinOff = true;
        userJoinOrg()
          .then(() => {
            Toast("加入成功");
            setTimeout(() => {
              window.location.reload();
            }, 300);
          })
          .catch(() => {});
      } else if (val.type == 3) {
        sureUserJoinMes()
          .then(() => {
            this.showUserIsJoin = false;
            this.leadJoin = false;
          })
          .catch(() => {});
      }
    },
    //排除用户直接加入机构
    userApplyOrgInit(remarkName = "") {
      userApplyOrg({ remarkName }).then(res => {
        if (res) {
          // Toast("加入成功");
          Toast("您的申请已提交，正在审核中");
          this.applyType = 1;
        }
      });
    },
    showMoreFn(index) {
      let item = this.pageList[index];
      item.isHidden = !item.isHidden;
      if (!item.isHidden) {
        item.height = Math.floor((this.cliH * 470) / 375) + "px";
      } else {
        let cl = "drawerH" + index,
          clb = "showMore" + index;
        let h =
          document.getElementsByClassName(cl)[0].clientHeight +
          document.getElementsByClassName(clb)[0].clientHeight / 2;
        item.height = h + "px";
      }
      item.isHidden
        ? (item.showMoreTxt = "点击收起全部课程")
        : (item.showMoreTxt = "点击展开全部课程");
      dataBurialPoint("A001", "A001-003-01");
    },
    getList() {
      let _this = this;
      getIndexPage({ orgId: this.orgId })
        .then(r => {
          this.bannerData = r.slideshowList;
          let allData = r.blockList,
            newArr = [];
          if (allData && allData.length > 0) {
            this.contentStatus = 3;
          } else {
            this.configDataStatus = 2;
          }
          allData.forEach(function(val) {
            //1课程2考试
            if (val.type == 1) {
              newArr.push({
                type: 1,
                isHidden: false,
                height: _this.height,
                showMoreTxt: "点击展开全部课程",
                list: val
              });
            }
            if (val.type == 2) {
              if (val.testingList && val.testingList.length > 3) {
                val.testingList = val.testingList.slice(0, 3);
              }
              newArr.push(val);
            }
          });

          this.pageList = newArr;
          this.isNoPageList = newArr.length == 0 ? 2 : 3;
          this.$nextTick(() => {
            let plateTestEl = document.getElementsByClassName("plate-test")[0];
            if (plateTestEl && plateTestEl.offsetTop > 800) {
              this.isToast = true;
            }
          });
        })
        .catch(() => {
          this.isNoPageList = 2;
        });
    },
    handleScroll() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      if (top > 200) {
        this.isToast = false;
        return;
      }
    }
  }
};
